<template>
  <div class="">
    <ContainerLayout :isOverview="isOverview">
      <template v-slot:contentPart>
        <component :is="dynamicComponent.content"/>
      </template>
      <template v-slot:contextActionPanel>
        <ActionPanel :actions="actionsForPanel" />
      </template>
      <template v-slot:contextPart>
        <component :is="dynamicComponent.context"/>
      </template>
    </ContainerLayout>
  </div>
</template>

<script>
import ContainerLayout from '@/components/wrld/generic/ContainerLayout'
import ActionPanel from '@/components/wrld/generic/ActionPanel'

import DropOverviewContent from '@/components/drops/DropOverviewContent'
import DropOverviewContext from '@/components/drops/DropOverviewContext'
import DropDetailContent from '@/components/drops/DropDetailContent'
import DropDetailContext from '@/components/drops/DropDetailContext'

export default {
  name: 'Test',
  components: {
    ContainerLayout,
    ActionPanel,
    DropOverviewContent,
    DropOverviewContext,
    DropDetailContent,
    DropDetailContext
  },
  props: {
    selectedView: String
  },
  data () {
    return {}
  },
  computed: {
    isOverview () {
      return this.selectedView === 'overview'
    },
    actionsForPanel () {
      switch (this.selectedView) {
        case 'overview':
          return [{
            icon: 'edit',
            name: 'Detail',
            callback: this.goToDetail
          }]
        case 'detail':
          return [{
            icon: 'fas fa-archive',
            name: 'Go to overview',
            callback: this.goToOverview
          }]
        default: // default is overview
          return [{
            icon: 'edit',
            name: 'Detail',
            callback: this.goToDetail
          }]
      }
    },
    dynamicComponent () {
      switch (this.selectedView) {
        case 'overview':
          return {
            content: 'DropOverviewContent',
            context: 'DropOverviewContext'
          }
        case 'detail':
          return {
            content: 'DropDetailContent',
            context: 'DropDetailContext'
          }
        default: // default is overview
          return {
            content: 'DropOverviewContent',
            context: 'DropOverviewContext'
          }
      }
    }
  },
  methods: {
    goToDetail (resourceID) {
      console.log('goToDetail')
      this.$router.push({ name: 'TestDetail' })
    },
    goToOverview (resourceID) {
      console.log('goToOverview')
      this.$router.push({ name: 'Test' })
    }
  },
  created () {}
}
</script>

<style lang="scss" scoped>

</style>
